export default "__VITE_ASSET__DYhtupX___"